@use "../styles/breakpoint.module.scss" as *;

.root {
    composes: repeater from "../styles/layout.module.scss";

    --default-columns: col-start 4 / col-end 9;

    @media ($below-tablet) {
        --default-columns: col-start 2 / col-end 11;
    }

    @media ($below-mobile) {
        --default-columns: content-start / content-end;
    }

    :where(& > *) {
        grid-column: var(--default-columns);
    }
}
